<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <div v-if="saveMessage" class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4">
        {{ $t('declarations.success') }}
      </div>
      <h1 class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase">
        {{ this.decalarationsPageTitle }}
      </h1>
      <div v-if="route_name === 'sessionlessDeclaration'">
        <div v-if="requets_declarations">
          <div class="bg-white shadow-md rounded my-6" v-if="requets_declarations.length > 0">
            <table class="text-left w-full border-collapse">
              <tbody>
                <tr class="hover:bg-grey-lighter" v-for="(lab, index) in requets_declarations" :key="index">
                  <td class="py-4 px-6 border-b border-grey-light">{{ lab.code_name == 'INVESTOR_FORM' ? $t("ecosystem.investor_declaration") : lab.name }}</td>
                  <td class="py-4 px-6 border-b border-grey-light text-right">
                    <sp-button theme="outline-blue" space="small" @click="applyRequest(formatDeclarationCodeName(lab.code_name))">
                      {{ $t('declarations.make_declaration') }}
                    </sp-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h1 v-if="investorType == 'Fonds investissement'" class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase">
            {{ $t("demandes.new_garanted_call_request") }}
        </h1>
        <div v-if="investorType == 'Fonds investissement'" class="table-responsive bg-white shadow-md rounded my-6 mt-0">
          <table class="text-left w-full border-collapse">
            <thead v-if="route_name === 'sessionlessDeclaration'">
              <tr>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
                  {{ $t("demandes.startup_name") }}
                </th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
                  {{ $t("demandes.label_statut") }}
                </th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
                  {{ $t("demandes.num_tranch") }}
                </th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
                  {{ $t("demandes.liberation_date") }}
                </th>
                <th class="py-4 px-22 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light text-center">
                  {{ $t("demandes.action") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="hover:bg-grey-lighter" v-for="(currDec, index) in investorGuaranteeForms" :key="index">
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span>{{$t(`${currDec.responses[1].content}`)}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span>{{ currDec.relatedStartup && currDec.relatedStartup[0].status == 12 ? 'Retiré' : 'Actif' }}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span>{{ currDec.numTranch }}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span>{{ currDec.liberationDate }}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-blue text-right">
                  <sp-button
                    v-if="currDec.relatedStartup && currDec.relatedStartup[0].status != 12 && ['Prélabel', 'Label'].includes(currDec.relatedStartup[0].type)"
                    theme="outline-blue"
                    space="small"
                    :disabled="shouldDisableButton(currDec) || currDec.status != 2 || currDec.relatedDec"
                    @click="applyRequest('INVESTOR_CALL_GUARANTEE_FORM', currDec)"
                  >
                    {{ $t('demandes.make_declaration_call') }}
                  </sp-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <tabs></tabs>
    </div>
  </div>
</template>


<style>
table.border-separate {
  border-spacing: 0 10px;
}

table.border-separate tbody tr {
  box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
  border-radius: 4px;
}

table.border-separate tbody tr:hover {
  box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
}

.table.border-separate tbody td {
  vertical-align: middle;
  border-color: rgba(29, 57, 100, 0.13);
}

.table.border-separate tbody tr:hover td {
  border-color: rgba(29, 57, 100, 0.23);
}

.table.border-separate thead th,
.table.border-separate thead td {
  border: none;
}
</style>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import {
  CLEAR_SAVE_MESSAGE,
  GET_INVESTORS_REQUESTS,
  CHECK_INVESTORS_REQUESTS,
  GET_CURRENT_REQUESTS_DECLARATIONS,
  GET_COMPLETED_REQUESTS_DECLARATIONS,
  FETCH_ECOSYSTEM_APPLICATION
} from "@/store/actions.type";
import ButtonVue from "../../components/spKit/Button.vue";

import store from "@/store";
import CompanyVue from "../../components/pages/Company.vue";
import Tabs from "../../components/Candidat/Tabs.vue";
import Loader from "@/components/Loader.vue";
import {
  SET_HashId,
  SET_ECOSYSTEM_MENU_ACTIVE,
  SET_SHARED_DATA
} from "@/store/mutations.type";

export default {
  name: "sessionlessDeclaration",
  components: {
    "sp-button": ButtonVue,
    company: CompanyVue,
    tabs: Tabs,
    Loader
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(CLEAR_SAVE_MESSAGE);
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, false);
    next();
  },
  data() {
    return {
      requests: null,
      checkApp: false,
      labelData: null,
      loading: false,
      messageCompany: false,
      requets_declarations: [],
      companyData: null,
      currRequestDeclarations: [],
      complRequestDeclarations: [],
      route_name: null,
      formName: null,
      currentFormName: null,
      currDec: null,
      allRequestDeclarations: [],
      investorType: null,
    };
  },
  mounted() {
    this.route_name = this.$route.name;
    this.formName = this.$route.params.formName;
    this.ecoAppId = this.$route.params.app_id;
    this.appType = this.$route.params.appType;
    // Current + Completed Requests
    this.$store
    .dispatch(GET_CURRENT_REQUESTS_DECLARATIONS, this.$route.params.app_id)
    .then(currentData => {
      this.currRequestDeclarations = currentData;
      this.$store
        .dispatch(GET_COMPLETED_REQUESTS_DECLARATIONS, this.$route.params.app_id)
        .then(completedData => {
          this.complRequestDeclarations = completedData;
          this.allRequestDeclarations = currentData.concat(completedData);
        });
    });
    this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, this.$route.params.app_id);
    // List requests declarations
    this.$store.dispatch(GET_INVESTORS_REQUESTS, this.$route.params.app_id).then(data => {
      this.requets_declarations = data.requests_declarations;
    });
    // List requests declarations
    this.$store.dispatch(CHECK_INVESTORS_REQUESTS, this.$route.params.app_id).then(data => {
      this.investorType = data.investorType;
      // this.requets_declarations = data.requests_declarations;
    });
    if (this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true') {
      this.loading = false;
    }
  },
  methods: {
    applyRequest(id, currDec) {
      this.$store.commit(SET_SHARED_DATA, currDec);
      console.log(id);
      console.log(currDec);
      if(id == 'INVESTOR_CALL_GUARANTEE_FORM' && currDec && currDec.code_name == 'INVESTOR_GUARANTEE_FORM' && currDec.status == '2') {
        this.$router.push({
          name: "declarationForm",
          params: {
            formName: id,
            ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
            appType: this.ecosystemApp.application.type.toLowerCase(),
            id: currDec.id
          }
        });
      } else {
        this.$router.push({
          name: "declarationForm",
          params: {
            formName: id,
            ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
            appType: this.ecosystemApp.application.type.toLowerCase()
          }
        });
      }
    },
    formatDeclarationCodeName(code) {
      return code.toLowerCase().replaceAll("_", "-");
    },
    shouldDisableButton(lab) {
      if(lab.code_name == "INVESTOR_GUARANTEE_FORM")
      return !this.hasGroupDeclaration;
    }
  },
  computed: {
    ...mapGetters(["session", "hashId", "LabelApplication", "ecosystemApp"]),
    ...mapActions(['updateCurrDec']), // Add this line to map the updateCurrDec action
    currentApplicationType() {
      return this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true' ?
        this.ecosystemApp.application.type :
        this.session.startup_application.type;
    },
    isStartupEcosystem() {
      let startupEco = false;
      let hashId = this.$route.params.app_id || this.$route.params.ecoAppId;
      if (hashId) {
        if (
          this.ecosystemApp &&
          this.ecosystemApp.application &&
          ["Investor"].includes(this.ecosystemApp.application.type) && this.$route.params.app_id
        ) {
          startupEco = true;
        }
      }

      return startupEco;
    },
    decalarationsPageTitle() {
      return this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true' ?
        this.$i18n.t('declarations.new_declaration_reporting'):
        this.$i18n.t('declarations.new_declaration');
    },
    ...mapState({
      saveMessage: state => state.request.saveMessage
    }),
    hasGroupDeclaration() {
      if (!this.complRequestDeclarations) {
        return false;
      }
      const groupDeclaration = this.complRequestDeclarations.find(
        declaration => declaration.code_name === "INVESTOR_GUARANTEE_FORM"
      );
      return Boolean(groupDeclaration);
    },
    investorGuaranteeForms() {
      return this.allRequestDeclarations.filter(
        (currDec) => currDec.code_name === "INVESTOR_GUARANTEE_FORM" && (!currDec.relatedDec || (currDec.relatedDec && currDec.relatedDec == false))
      );
    }
  }
};
</script>